import { render } from "./LogicalRouterTab.vue?vue&type=template&id=ca35f796"
import script from "./LogicalRouterTab.vue?vue&type=script&lang=js"
export * from "./LogicalRouterTab.vue?vue&type=script&lang=js"

import exportComponent from "/build/cloudstack/dist/rpmbuild/BUILD/cloudstack-4.18.1.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__